import { darken } from 'polished';
import styled, { css } from 'styled-components';

type ContainerProps = {
  isEditing: boolean;
};

export const Container = styled.div<ContainerProps>`
  flex: 1;
  display: grid;
  padding: 20px 32px 32px;
  grid-template-columns: 1fr 292px;
  grid-template-rows: repeat(6, 84.88px);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  overflow: auto;

  > div:nth-child(1) {
    grid-area: 1 / 2 / 3 / 3;
  }

  > div:nth-child(2) {
    grid-area: 1 / 1 / 2 / 2;
  }

  > div:nth-child(3) {
    grid-area: 2 / 1 / 3 / 2;
  }

  > div:nth-child(4) {
    grid-area: 3 / 1 / 5 / 2;
  }

  > div:nth-child(5) {
    grid-area: 3 / 2 / 4 / 3;
  }

  > div:nth-child(6) {
    grid-area: 4 / 2 / 5 / 3;
  }

  > div:nth-child(7) {
    grid-area: 5 / 2 / 6 / 3;
    display: flex;
    gap: 10px;
  }

  > div:nth-child(8) {
    grid-area: 5 / 1 / 6 / 2;
  }

  > div:nth-child(9) {
    grid-area: 6 / 1 / 7 / 2;
  }

  > div:nth-child(10) {
    grid-area: 6 / 2 / 7 / 3;

    > div {
      display: flex;

      span {
        background-color: ${({ theme }) => theme.colors.white};
        border: 2px solid ${({ theme }) => theme.colors.lightGrey};
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        font-family: 'Sora', sans-serif;
        font-size: 13px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.black};
        border-left: none;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        transition: all 0.2s ease-in-out;

        &.disabled {
          cursor: not-allowed;
          background: #e5e5e5;
          border-color: #d9d9d9;
        }
      }
    }
  }

  > div:nth-child(11) {
    grid-area: 7 / 1 / 8 / 3;
  }

  /* ${({ isEditing }) =>
    isEditing
      ? css`
          > div:nth-child(9) {
            grid-area: 6 / 1 / 7 / 2;
          }

          > div:nth-child(10) {
            grid-area: 6 / 2 / 7 / 3;
          }
        `
      : css`
          > div:nth-child(9) {
            grid-area: 6 / 1 / 7 / 3;
          }
        `} */

  @media only screen and (max-width: 768px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    > div:nth-child(1) {
      height: 196px;
      max-height: 196px;
    }

    > div:nth-child(4) {
      order: 9;
      height: 150px;
    }
  }
`;

export const HelpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-family: 'Sora', sans-serif;
  font-weight: 500;
  height: 38px;
  background-color: #329bfc;
  color: #ffffff;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  margin-top: 26px;

  &:hover {
    background-color: ${darken(0.1, '#329bfc')};
  }
`;
